var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referral mx-1"},[_c('SentTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }